/**
 * What a rename would send, or nothing (spec 227 FR-005): the draft with its
 * surrounding spaces gone, unless that leaves it empty or the same as the name
 * already saved. The field, Enter and Save all ask this one question, so none of
 * them can disagree about whether there is anything to save.
 */
export function renameChange(current: string, draft: string): string | null {
  const trimmed = draft.trim();
  if (trimmed === '' || trimmed === current) return null;
  return trimmed;
}
